import { CampaignStatus, MnoStatus, SenderIdType } from '@/constants/enum';

export const humanize = (str?: string | null) => {
  if (typeof str === 'string') {
    return str
      .replace(/[-_]/g, ' ')
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
  return '';
};

export const humanizeAuthenticatedUser = (value: string | null) => {
  if (value === 'TCR_SUPPORT') {
    return 'TCR Support';
  }
  if (value === 'TCR_SYSTEM') {
    return 'TCR System';
  }
  return value || 'N/A';
};

export const constantizeAuthenticatedUser = (value?: string) => {
  if (value === 'TCR Support') {
    return 'TCR_SUPPORT';
  }
  if (value === 'TCR System') {
    return 'TCR_SYSTEM';
  }
  return value;
};

export const humanizeCampaignStatus = (value: string) => {
  if (value === CampaignStatus.Active) {
    return 'Active';
  }
  if (value === CampaignStatus.Expired) {
    return 'Deactivated';
  }
  return value;
};

export const humanizeSenderIdType = (value?: string) => {
  if (value === SenderIdType.LongCode) {
    return 'Long Code';
  }
  if (value === SenderIdType.ShortCode) {
    return 'Short Code';
  }
  return value;
};

export const humanizeMnoStatus = (value: string) => {
  if (value === MnoStatus.Review) {
    return 'Pending MNO Review';
  }
  if (value === MnoStatus.Rejected) {
    return 'Rejected';
  }
  if (value === MnoStatus.Registered) {
    return 'Active';
  }
  if (value === MnoStatus.Suspended) {
    return 'Suspended';
  }
  return value;
};
